<div class="telephony-settings">
  <div class="settings-header">
    <div>
      <p class="eyebrow">Telephony Plugin</p>
      <h1>Integration Settings</h1>
    </div>
    <div class="settings-actions">
      <button type="button" class="btn btn-secondary" (click)="reset()">Reset</button>
      <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>

  <div class="save-error" *ngIf="saveError">
    <div *ngFor="let line of saveError.split('\n')">{{ line }}</div>
  </div>

  <div class="settings-grid" *ngIf="config">
    <section class="settings-panel">
      <h2>Host Profile</h2>
      <label>
        <span>Plugin ID</span>
        <input [(ngModel)]="config.pluginId" />
      </label>
      <label>
        <span>Host System</span>
        <input [(ngModel)]="config.hostSystem" />
      </label>
      <label>
        <span>Mount Path</span>
        <input [(ngModel)]="config.mountPath" />
      </label>
      <p class="adapter-hint">
        Enabled frontend mounts: /telephony, /contact-center, /call-center. Custom mount paths are published in the manifest for host systems, but this Angular shell must still define the route.
      </p>
    </section>

    <section class="settings-panel">
      <h2>Labels</h2>
      <label>
        <span>Agent Label</span>
        <input [(ngModel)]="config.labels.agent" />
      </label>
      <label>
        <span>Caller Label</span>
        <input [(ngModel)]="config.labels.caller" />
      </label>
      <label>
        <span>Business Record Label</span>
        <input [(ngModel)]="config.labels.businessRecord" />
      </label>
      <label>
        <span>Internal Peer Label</span>
        <input [(ngModel)]="config.labels.internalPeer" />
      </label>
    </section>

    <section class="settings-panel">
      <h2>Role Mapping</h2>
      <label>
        <span>Agent Role</span>
        <input [(ngModel)]="config.roles.agent" />
      </label>
      <label>
        <span>Supervisor Role</span>
        <input [(ngModel)]="config.roles.supervisor" />
      </label>
      <label>
        <span>Admin Role</span>
        <input [(ngModel)]="config.roles.admin" />
      </label>
    </section>

    <section class="settings-panel">
      <h2>SLA Thresholds</h2>
      <label>
        <span>Target Answer Seconds</span>
        <input type="number" min="1" [(ngModel)]="config.sla.targetAnswerSeconds" />
      </label>
      <label>
        <span>Target Handle Seconds</span>
        <input type="number" min="1" [(ngModel)]="config.sla.targetHandleSeconds" />
      </label>
      <label>
        <span>Target Hold Seconds</span>
        <input type="number" min="1" [(ngModel)]="config.sla.targetHoldSeconds" />
      </label>
      <label>
        <span>Callback Overdue Minutes</span>
        <input type="number" min="0" [(ngModel)]="config.sla.callbackOverdueMinutes" />
      </label>
    </section>

    <section class="settings-panel">
      <h2>Business Adapter</h2>
      <label>
        <span>Adapter Type</span>
        <select [(ngModel)]="config.adapter.type">
          <option value="grmis">GRMIS</option>
          <option value="hmis">HMIS</option>
          <option value="crm">CRM</option>
          <option value="webhook">Webhook</option>
          <option value="none">None</option>
        </select>
      </label>
      <p class="adapter-hint">{{ adapterHint }}</p>
      <label>
        <span>Caller Lookup URL</span>
        <input [(ngModel)]="config.adapter.callerLookupUrl" />
      </label>
      <label>
        <span>Wrap-up URL</span>
        <input [(ngModel)]="config.adapter.wrapUpUrl" />
      </label>
      <label>
        <span>Recording Webhook URL</span>
        <input [(ngModel)]="config.adapter.recordingWebhookUrl" />
      </label>
    </section>

    <section class="settings-panel">
      <h2>Adapter Test</h2>
      <label>
        <span>Phone Number</span>
        <input [(ngModel)]="testPhone" placeholder="03001234567" />
      </label>
      <button type="button" class="btn btn-primary test-btn" [disabled]="testLoading || !testPhone.trim()" (click)="testLookup()">
        {{ testLoading ? 'Testing...' : 'Test Lookup' }}
      </button>
      <div class="test-result" *ngIf="testResult">
        <div><strong>Host:</strong> {{ testResult.hostSystem }}</div>
        <div><strong>{{ testResult.callerLabel }}:</strong> {{ testResult.phone }}</div>
        <div><strong>{{ testResult.businessRecordLabel }} Records:</strong> {{ testResult.businessRecordCount }}</div>
        <div><strong>Recent Calls:</strong> {{ testResult.recentCallCount }}</div>
      </div>
      <div class="test-error" *ngIf="testError">{{ testError }}</div>
    </section>

    <section class="settings-panel">
      <div class="panel-title-row">
        <h2>Integration Health</h2>
        <button type="button" class="btn btn-secondary btn-sm" (click)="loadHealth()">
          {{ healthLoading ? 'Checking...' : 'Check' }}
        </button>
      </div>
      <div class="health-status" *ngIf="healthResult" [class.health-ready]="healthResult.status === 'READY'">
        {{ healthResult.status }}
      </div>
      <div class="health-list" *ngIf="healthResult">
        <div class="health-row" *ngFor="let check of healthResult.checks" [class.health-row-ok]="check.ok">
          <span class="material-icons">{{ check.ok ? 'check_circle' : 'error' }}</span>
          <span>{{ check.label }}</span>
        </div>
      </div>
      <div class="test-error" *ngIf="healthError">{{ healthError }}</div>
    </section>

    <section class="settings-panel settings-panel-wide">
      <h2>Wrap-up Options</h2>
      <div class="options-grid">
        <label>
          <span>Dispositions</span>
          <textarea rows="7"
                    [ngModel]="config.wrapUpOptions.dispositions.join('\n')"
                    (ngModelChange)="config.wrapUpOptions.dispositions = parseOptions($event)"></textarea>
        </label>
        <label>
          <span>Call Reasons</span>
          <textarea rows="7"
                    [ngModel]="config.wrapUpOptions.callReasons.join('\n')"
                    (ngModelChange)="config.wrapUpOptions.callReasons = parseOptions($event)"></textarea>
        </label>
        <label>
          <span>Sources</span>
          <textarea rows="7"
                    [ngModel]="config.wrapUpOptions.sources.join('\n')"
                    (ngModelChange)="config.wrapUpOptions.sources = parseOptions($event)"></textarea>
        </label>
      </div>
      <p class="adapter-hint">Enter one option per line. These lists drive the agent console without changing code.</p>
    </section>

    <section class="settings-panel settings-panel-wide">
      <div class="panel-title-row">
        <h2>Queue Mapping</h2>
        <button type="button" class="btn btn-secondary btn-sm" (click)="addQueue()">+ Add Queue</button>
      </div>
      <p class="adapter-hint">Map Asterisk queue names to host-system department labels. These labels appear in the agent console and supervisor views.</p>
      <div class="queue-mapping-table" *ngIf="config.queueMapping?.length">
        <div class="queue-mapping-header">
          <span>Queue Name (Asterisk)</span>
          <span>Label (Host System)</span>
          <span>Priority</span>
          <span>Active</span>
          <span></span>
        </div>
        <div class="queue-mapping-row" *ngFor="let entry of config.queueMapping; let i = index">
          <input [(ngModel)]="entry.name" placeholder="q_general" />
          <input [(ngModel)]="entry.label" placeholder="General Inquiry" />
          <select [(ngModel)]="entry.priority">
            <option value="High">High</option>
            <option value="Medium">Medium</option>
            <option value="Low">Low</option>
          </select>
          <input type="checkbox" [(ngModel)]="entry.active" />
          <button type="button" class="btn-icon" (click)="removeQueue(i)" title="Remove">✕</button>
        </div>
      </div>
      <p class="adapter-hint" *ngIf="!config.queueMapping?.length">No queues configured. Click + Add Queue to define one.</p>
    </section>

    <!-- IVR Menu Configuration -->
    <section class="settings-panel settings-panel-wide">
      <div class="panel-title-row">
        <h2>IVR Menus</h2>
        <button type="button" class="btn btn-secondary btn-sm" (click)="addIvrMenu()">+ Add Menu</button>
      </div>
      <p class="adapter-hint">Define IVR key-press menus. Each menu has a greeting and a set of digit options that route callers to queues, extensions, or other menus.</p>

      <div *ngFor="let menu of config.ivrMenus; let mi = index" class="ivr-menu-block">
        <div class="ivr-menu-header">
          <input [(ngModel)]="menu.menuId" placeholder="Menu ID (e.g. main)" class="input-sm" />
          <input [(ngModel)]="menu.name"   placeholder="Display name" class="input-sm" />
          <button type="button" class="btn-icon btn-icon-danger" (click)="removeIvrMenu(mi)" title="Remove menu">✕</button>
        </div>
        <input [(ngModel)]="menu.greeting" placeholder="Greeting prompt text or audio file" class="input-full" />

        <div class="ivr-options-table" *ngIf="menu.options?.length">
          <div class="ivr-options-header">
            <span>Key</span><span>Label</span><span>Action</span><span>Target</span><span></span>
          </div>
          <div class="ivr-options-row" *ngFor="let opt of menu.options; let oi = index">
            <input [(ngModel)]="opt.key"    placeholder="1" class="input-key" maxlength="1" />
            <input [(ngModel)]="opt.label"  placeholder="Complaints" />
            <select [(ngModel)]="opt.action">
              <option value="queue">Queue</option>
              <option value="menu">Menu</option>
              <option value="extension">Extension</option>
              <option value="hangup">Hang Up</option>
            </select>
            <input [(ngModel)]="opt.target" placeholder="q_general" />
            <button type="button" class="btn-icon" (click)="removeIvrOption(menu, oi)" title="Remove">✕</button>
          </div>
        </div>
        <button type="button" class="btn btn-secondary btn-xs" (click)="addIvrOption(menu)">+ Add Option</button>
      </div>

      <p class="adapter-hint" *ngIf="!config.ivrMenus?.length">No IVR menus configured.</p>
    </section>

    <!-- DID / UAN Routing -->
    <section class="settings-panel settings-panel-wide">
      <div class="panel-title-row">
        <h2>DID / UAN Routing</h2>
        <button type="button" class="btn btn-secondary btn-sm" (click)="addDidRoute()">+ Add Number</button>
      </div>
      <p class="adapter-hint">Map incoming phone numbers (DIDs or UANs) to IVR menus, queues, or direct extensions.</p>

      <div class="queue-mapping-table" *ngIf="config.didRouting?.length">
        <div class="queue-mapping-header">
          <span>DID / UAN</span><span>Label</span><span>Route To</span><span>Target</span><span>Active</span><span></span>
        </div>
        <div class="queue-mapping-row" *ngFor="let entry of config.didRouting; let i = index">
          <input [(ngModel)]="entry.did"    placeholder="051-111-000-000" />
          <input [(ngModel)]="entry.label"  placeholder="Main Helpline" />
          <select [(ngModel)]="entry.targetType">
            <option value="ivr">IVR Menu</option>
            <option value="queue">Queue</option>
            <option value="extension">Extension</option>
          </select>
          <input [(ngModel)]="entry.target" placeholder="main" />
          <input type="checkbox" [(ngModel)]="entry.active" />
          <button type="button" class="btn-icon" (click)="removeDidRoute(i)" title="Remove">✕</button>
        </div>
      </div>
      <p class="adapter-hint" *ngIf="!config.didRouting?.length">No DID routes configured.</p>
    </section>

    <!-- Business Hours -->
    <section class="settings-panel settings-panel-wide">
      <div class="panel-title-row">
        <h2>Business Hours</h2>
      </div>
      <p class="adapter-hint">Define when the contact centre is open. Calls outside these hours can be routed to voicemail or an after-hours message.</p>

      <div class="bh-timezone-row">
        <label for="bh-timezone">Timezone</label>
        <input id="bh-timezone" [(ngModel)]="config.businessHours.timezone" placeholder="Asia/Karachi" class="input-sm" />
      </div>

      <div class="bh-schedule-table">
        <div class="bh-schedule-header">
          <span>Day</span><span>Open</span><span>Opens</span><span>Closes</span>
        </div>
        <div class="bh-schedule-row" *ngFor="let day of config.businessHours.weekdays">
          <span>{{ day.day }}</span>
          <input type="checkbox" [(ngModel)]="day.open" />
          <input type="time" [(ngModel)]="day.openTime"  [disabled]="!day.open" />
          <input type="time" [(ngModel)]="day.closeTime" [disabled]="!day.open" />
        </div>
      </div>

      <div class="panel-title-row" style="margin-top:1rem">
        <h3>Public Holidays</h3>
        <button type="button" class="btn btn-secondary btn-sm" (click)="addHoliday()">+ Add Holiday</button>
      </div>
      <div class="queue-mapping-table" *ngIf="config.businessHours.holidays?.length">
        <div class="queue-mapping-header">
          <span>Date (YYYY-MM-DD)</span><span>Name</span><span></span>
        </div>
        <div class="queue-mapping-row" *ngFor="let h of config.businessHours.holidays; let i = index">
          <input [(ngModel)]="h.date" type="date" />
          <input [(ngModel)]="h.name" placeholder="Independence Day" />
          <button type="button" class="btn-icon" (click)="removeHoliday(i)" title="Remove">✕</button>
        </div>
      </div>
      <p class="adapter-hint" *ngIf="!config.businessHours.holidays?.length">No holidays configured.</p>
    </section>

    <section class="settings-panel settings-panel-wide" *ngIf="manifest">
      <h2>Published Pages</h2>
      <div class="manifest-summary">
        <span>Version {{ manifest.version || '1.0' }}</span>
        <span>{{ manifest.adapterType }}</span>
        <span>{{ manifest.capabilities?.length || 0 }} capabilities</span>
      </div>
      <div class="manifest-list">
        <div class="manifest-row" *ngFor="let page of manifest.pages">
          <span [class.page-disabled]="page.enabled === false">{{ page.title }}</span>
          <code>{{ page.route }}</code>
          <span class="page-roles" *ngIf="page.visibleTo?.length">{{ page.visibleTo!.join(', ') }}</span>
          <span class="page-badge page-badge-off" *ngIf="page.enabled === false">disabled</span>
        </div>
      </div>
    </section>

    <section class="settings-panel settings-panel-wide" *ngIf="manifest">
      <h2>Published API Contract</h2>
      <div class="contract-grid">
        <div>
          <h3>API</h3>
          <div class="manifest-list">
            <div class="manifest-row" *ngFor="let item of manifestApiEntries">
              <span>{{ item.key }}</span>
              <code>{{ item.value }}</code>
            </div>
          </div>
        </div>
        <div>
          <h3>Exports</h3>
          <div class="manifest-list">
            <div class="manifest-row" *ngFor="let item of manifestExportEntries">
              <span>{{ item.key }}</span>
              <code>{{ item.value }}</code>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div class="settings-toast" *ngIf="toast">{{ toast }}</div>
</div>
